import api from '@/services/api'

export default {
  namespaced: true,
  state() {
    return {
      activeDepartureFlight: null,
      activeReturnFlight: null,
      departureFlights: [],
      returnFlights: [],
      loading: false,
      error: null,
    }
  },
  mutations: {
    SET_DEPARTURE_FLIGHTS( state, payload ) {
      state.departureFlights = payload
    },
    SET_RETURN_FLIGHTS( state, payload ) {
      state.returnFlights = payload
    },
    SET_ACTIVE_DEPARTURE_FLIGHT( state, payload ) {
      state.activeDepartureFlight = null
      state.activeDepartureFlight = payload
      console.log( state.activeDepartureFlight )
    },
    SET_ACTIVE_RETURN_FLIGHT( state, payload ) {
      state.activeReturnFlight = null
      state.activeReturnFlight = payload
      console.log( state.activeReturnFlight )
    },
    CLEAR_FLIGHTS( state ) {
      state.activeDepartureFlight = null
      state.activeReturnFlight = null
      state.departureFlights = []
      state.returnFlights = []
    },
    SET_LOADING( state, status ) {
      state.loading = status
    },
    SET_ERROR( state, error ) {
      state.error = error
    },
  },
  actions: {
    async readAvailableFlights( {commit}, payload ) {
      commit( 'SET_LOADING', true )
      commit( 'SET_ERROR', null )

      try {
        // Departure flights
        const departureResponse = await api.readSlots({
          origin: payload.origin,
          destination: payload.destination,
          date: payload.departureDate,
          passengersCount: payload.passengersCount
        })

        commit('SET_DEPARTURE_FLIGHTS', departureResponse.data )

        // Return flights (optional)
        if( payload.returnDate ) {
          const returnResponse = await api.readSlots({
            origin: payload.destination,
            destination: payload.origin,
            date: payload.returnDate,
            passengersCount: payload.passengersCount
          })

          commit( 'SET_RETURN_FLIGHTS', returnResponse.data )
        }

      } catch( error ) {
        commit( 'SET_ERROR', error )
      } finally {
        commit( 'SET_LOADING', false )
      }
    }
  }
}